// 公告列表
export const getNotificationList = params => {
  return window._this.$http.get(`/erp/DepartmentNotice/index`, {
    params,
  });
};

// 公告详情
export const getNotificationDetail = params => {
  return window._this.$http.get(`/erp/DepartmentNotice/detail`, {
    params,
  });
};

// 已读名单
export const getReadList = params => {
  return window._this.$http.get(`/erp/DepartmentNotice/readList`, {
    params,
  });
};

// 新建公告
export const createNotification = params => {
  return window._this.$http.post(`/erp/DepartmentNotice/create`, params);
};

// 获取下拉选项
export const getNotificationDropdownList = params => {
  return window._this.$http.get(`/erp/DepartmentNotice/condition`, {
    params,
  });
};



// WEBPACK FOOTER //
// ./src/api/notification.js